<template>
  <div class="sect-section">
    <div class="container">
      <div class="row mb-5">
        <div class="col-12 text-center">
          <h1 class="sect-title">Livros Essenciais</h1>
          <p class="lead text-muted" style="color: #e9ecef !important;">
            Descubra os principais lançamentos de Vampiro: A Máscara 5ª Edição e mantenha seu crônica abastecida
            com conhecimento oficial.
          </p>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-md-6 col-lg-4" v-for="book in books" :key="book.id">
          <article class="card book-card h-100">
            <img :src="book.image" class="card-img-top book-cover" :alt="`Capa do livro ${book.title}`" loading="lazy" />
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-start mb-2">
                <span class="badge bg-danger text-uppercase me-2">{{ book.type }}</span>
                <small class="text-muted">Lançado em {{ book.releaseYear }}</small>
              </div>
              <h5 class="card-title">{{ book.title }}</h5>
              <p class="card-subtitle mb-3 text-muted">{{ book.subtitle }}</p>
              <p class="card-text flex-grow-1">{{ book.description }}</p>
              <ul class="list-unstyled small text-muted mb-3">
                <li v-for="item in book.highlights" :key="item" class="mb-1">
                  <i class="bi bi-droplet-half me-2 text-danger"></i>{{ item }}
                </li>
              </ul>
              <a
                class="btn btn-vampire w-100 mt-auto"
                :href="book.storeLink"
                target="_blank"
                rel="noopener"
              >
                {{ book.storeCta }}
              </a>
            </div>
          </article>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 text-center">
          <button class="btn btn-outline-light" @click="$emit('go-back')">
            <i class="bi bi-arrow-left me-2"></i>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import bookImageVm5thEd from '../assets/bookImages/book_vm_5_edicao.jpg'
import bookImageCamarilla5thEd from '../assets/bookImages/camarilla_5_edicao.jpg'
import bookImageSabbat5thEd from '../assets/bookImages/sabbat_5_edicao.jpg'

export default {
  name: 'BooksView',
  data() {
    return {
      books: [
        {
          id: 'core-v5',
          title: 'Vampiro: A Máscara — Livro de Regras 5ª Edição',
          subtitle: 'O manual definitivo para narradores e jogadores.',
          description:
            'Traga a Noite Moderna à sua mesa com regras atualizadas, cronologia pós-Gehenna e ferramentas completas para montar coteries inesquecíveis.',
          type: 'Regra Básica',
          releaseYear: 2021,
          image: bookImageVm5thEd,
          highlights: [
            'Crônica abrangendo a retomada da Camarilla e Ascensão Anarquista',
            'Sistemas refinados de Fome, Compulsões e Ambições',
            'Mapas de facções, Disciplina e fichas prontas para iniciar em minutos'
          ],
          storeLink: 'https://www.amazon.com.br/Gal%C3%A1pagos-Jogos-WOD001-Vampiro-M%C3%A1scara/dp/6586644267/ref=asc_df_6586644267?mcid=7954b1a7ead83a7faebe537993a11802&tag=googleshopp00-20&linkCode=df0&hvadid=709857019392&hvpos=&hvnetw=g&hvrand=15719644353473239400&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=9102131&hvtargid=pla-1391719380186&psc=1&language=pt_BR&gad_source=1',
          storeCta: 'Ver oferta na livraria'
        },
        {
          id: 'camarilla-v5',
          title: 'Camarilla — Suplemento 5ª Edição',
          subtitle: 'Segredos da Torre de Marfim e suas guerras políticas.',
          description:
            'Aprofunde a estrutura da seita mais poderosa, descubra protocolos de Elysium, rituais de sangue e perfis dos anciões que regem o Mundo das Trevas.',
          type: 'Suplemento',
          releaseYear: 2022,
          image: bookImageCamarilla5thEd,
          highlights: [
            'Novas coteries oficiais e antagonistas prontos para campanha',
            'Detalhes de clãs como Banu Haqim e Lasombra dentro da Camarilla',
            'Ferramentas de política, status e jogos de influência'
          ],
          storeLink: 'https://www.amazon.com.br/Vampiro-M%C3%A1scara-Edi%C3%A7%C3%A3o-Camarilla-Suplemento/dp/6586600332/ref=pd_rhf_se_s_pd_sbs_rvi_d_sccl_1_4/138-0362870-2119009?pd_rd_w=6qxdB&content-id=amzn1.sym.549405bf-70e5-4bf7-9e8c-4c06fbb86a63&pf_rd_p=549405bf-70e5-4bf7-9e8c-4c06fbb86a63&pf_rd_r=ZQ5TN28BMZSBGC91BZQB&pd_rd_wg=rAtbR&pd_rd_r=25b48ae9-d784-433f-97cd-8309dbbf921f&pd_rd_i=6586600332&psc=1',
          storeCta: 'Listar na vitrine da loja'
        },
        {
          id: 'sabbat-v5',
          title: 'Sabbat: A Espada de Caim — Guia de Facção',
          subtitle: 'Explore a seita que abraça a Besta sem remorso.',
          description:
            'Conheça liturgias de Vaulderie, trilhas de iluminação e mecânicas para crônicas sangrentas com packs fanáticos que desafiam a Máscara.',
          type: 'Suplemento',
          releaseYear: 2022,
          image: bookImageSabbat5thEd,
          highlights: [
            'Perfis de bispos, ducti e rituais profanos do Sabbat',
            'Ferramentas para narrar cruzadas noturnas e campanhas globais',
            'Novas antagonistas e horrores das trilhas infernais'
          ],
          storeLink: 'https://www.amazon.com.br/Gal%C3%A1pagos-Jogos-Vampiro-M%C3%A1scara-Suplemento/dp/658660043X/ref=pd_bxgy_d_sccl_2/138-0362870-2119009?pd_rd_w=1rI8Z&content-id=amzn1.sym.e1672530-f86d-4706-becf-35c421ed2a84&pf_rd_p=e1672530-f86d-4706-becf-35c421ed2a84&pf_rd_r=7GSG69ZCVF4HBQ52K0GY&pd_rd_wg=3b8mE&pd_rd_r=bd986eb4-75d2-4186-ba03-d4ef0b7fbf90&pd_rd_i=658660043X&psc=1',
          storeCta: 'Adicionar link de parceiro'
        }
      ]
    }
  }
}
</script>

<style scoped>
.book-card {
  background: rgba(17, 17, 17, 0.92);
  border: 1px solid rgba(218, 165, 32, 0.25);
  color: #f8f9fa;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.book-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.35);
}

.book-cover {
  height: fit-content;
  object-fit: cover;
  border-bottom: 1px solid rgba(218, 165, 32, 0.25);
}
</style>
